import React from 'react';
import { DuplicateWarning, GoalFormCard } from '../parts';
import { GoalFlowScreenProps } from './types';

/** Activity / frequency / duration form, plus the duplicate warning. Shared by the start and build screens. */
export const ActivityForm: React.FC<GoalFlowScreenProps> = ({ goalFlow }) => (
  <>
    <GoalFormCard
      form={goalFlow.form}
      activityOptions={goalFlow.activityOptions}
      onActivityChange={goalFlow.setActivity}
      onFrequencyChange={goalFlow.setFrequency}
      onDurationChange={goalFlow.setDuration}
    />
    {goalFlow.isDuplicate && <DuplicateWarning name={goalFlow.duplicateName} />}
  </>
);
